/** @returns {Storage} */
export function getLocalStorage() {
	if (typeof localStorage !== 'undefined') return prefixedLocalStorage

	return fallbackLocalStorage
}

const map = new Map()
const prefix = key => `primerdocs_${key}`

const fallbackLocalStorage = {
	clear: () => map.clear(),
	getItem: key => map.get(prefix(key)) ?? null,
	key: index => [...map.keys()][index] ?? null,
	get length() {
		return map.size
	},
	removeItem: key => map.delete(prefix(key)),
	setItem: (key, value) => map.set(prefix(key), value),
}

const prefixedLocalStorage = {
	clear: () => localStorage.clear(),
	getItem: key => localStorage.getItem(prefix(key)),
	key: index => localStorage.key(index),
	get length() {
		return localStorage.length
	},
	removeItem: key => localStorage.removeItem(prefix(key)),
	setItem: (key, value) => localStorage.setItem(prefix(key), value),
}
